import script from "./MultipleGradesManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipleGradesManager.vue?vue&type=script&setup=true&lang=ts"

import "./MultipleGradesManager.vue?vue&type=style&index=0&id=0ae867f8&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae867f8"]])

export default __exports__